module.exports = __webpack_public_path__ + "static/media/invoice.b6002290.png";